import { validateRut } from "@fdograph/rut-utilities";
import { getDatosCiudadanoPorRut } from "./api";

const clean = rut => {
    return typeof rut === "string"
        ? rut.replace(/^0+|[^0-9kK]+/g, "").toLowerCase()
        : ""
}

export const cleanRut = clean;

export const validate = rut => validateRut(rut)

export const validatePrintCertificate = tramite => {
    if (!tramite.printCertificate || !tramite.fase) {
        return false
    }
    return true;
}

export const format = rut => {
    rut = clean(rut)

    var result = rut.slice(-4, -1) + "-" + rut.substr(rut.length - 1)
    for (var i = 4; i < rut.length; i += 3) {
        result = rut.slice(-3 - i, -i) + "." + result
    }

    return result
}


export const isAuthenticate = user => {
    if (user && user.token) {
        return true;
    }
    return false;
}

export const isAnalista = auth => {
    if (!auth) {
        return false
    }
    if (!auth.seguimiento) {
        return false
    }
    if (auth.seguimiento && auth.seguimiento.includes("view_all_tramites")) {
        return true
    }
    return false
}

export const singleInputValidator = (val1, errName, setError, otherValid, setData, setSpinner) => {


    let val = val1.trim()

    if(val===''){
        setError(errName, {type: "manual", message:"Debe seleccionar este campo"})
    }else{
        if(otherValid.length>0){
            otherValid.map((opt,index)=>{
                if(opt.option==="rutValidation"){
                  
                    if(!validate(cleanRut(val))){
                        setError(errName, {type: "manual", message:"RUT inválido"})
                        
                    }else{
                        
                        setError(errName, {type: "manual", message:""})
                        if(opt.updateFields){
                            setSpinner(true)
                            let rutSinDv = cleanRut(val).slice(0,-1)
                            getDatosCiudadanoPorRut(rutSinDv)
                            .then(res=> {
                                if(res.data!==null){
                                    setData(res.data.nombres, res.data.apellido_p, res.data.apellido_m, res.data.email, res.data.genero_id, res.data.fecha_nacimiento)
                                }
                                setSpinner(false)
                            })
                            .catch(err=>{
                                console.error(err)
                                setSpinner(false)
                            })
                            
                        }
                        
                    }
                }

                if(opt.option==='eMail'){
                    if(!validateMail(val)){
                        setError(errName, {type: "manual", message:"Correo inválido"})
                    }else{
                   
                        setError(errName, {type: "manual", message:""})
                    }
                }
                
                return null
            })
        }else{
            setError(errName, {type: "manual", message:""})
        }
        
    }

}

export const validateForm = (fields, setError) => {

    let aux = false

    fields.map((item, index)=>{
        if(item.dato===''){
            aux=true
            setError(item.errName, {type: "manual", message:"Debe seleccionar este campo"})
        }else{
            if(item.otherValid.length>0){
                item.otherValid.map((opt,index)=>{
                    if(opt.option==="rutValidation"){
                        if(!validate(cleanRut(item.dato))){
                            aux=true
                            setError(item.errName, {type: "manual", message:"RUT inválido"})
                        }else{
                       
                            setError(item.errName, {type: "manual", message:""})
                        }
                    }

                    if(opt.option==='eMail'){
                        if(!validateMail(item.dato)){
                            aux=true
                            setError(item.errName, {type: "manual", message:"Correo inválido"})
                        }else{
                       
                            setError(item.errName, {type: "manual", message:""})
                        }
                    }
                    return null
                })
            }else{
                setError(item.errName, {type: "manual", message:""})
            }
            
        }
        return null
    })

    return aux
}

export const validateMail = mail => {

    //eslint-disable-next-line
    var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
    if (mail !== null && mail !== "") {
      if (!mail.match(mailformat)) {
        return false
      } else {
        return true
      }
    }
  }

export const CORP_BLUE = "#0064AC"
